import api from "./axiosConfig";
import { API_ENDPOINTS } from "./apiConfig";
import type { ClientListResponse } from "../types/Client";
import type { SosContact } from "../types/Client";
import type { SosMessageLogPage, RecipientType } from "../types/Client";


export type ClientListParams = {
  page?: number;
  size?: number;
  sort?: string;
  hasWearable?: boolean;
  isRemote?: boolean;
};

export async function fetchClientList({
  page = 0,
  size = 20,
  sort,
  hasWearable,
  isRemote,
}: ClientListParams): Promise<ClientListResponse> {
  const params: Record<string, any> = { page, size, sort: sort ?? "id,DESC" };
  if (hasWearable !== undefined) params.hasWearable = hasWearable;
  if (isRemote !== undefined) params.isRemote = isRemote;

  const { data } = await api.get<ClientListResponse>(API_ENDPOINTS.adminClientList, { params });
  return data;
}

export async function fetchSosContactList(params: {
  clientId: number;
  page?: number;
  size?: number;
  sort?: string;
}) {
  const { clientId, page = 0, size = 10, sort = "id,ASC" } = params;
  const url = API_ENDPOINTS.adminClientSosContactList.replace("{id}", String(clientId));
  const res = await api.get(url, { params: { page, size, sort } });
  return res.data as { content: SosContact[] };
}

export async function sendSosMessage(id: number): Promise<void> {
  try {
    const res = await api.post(API_ENDPOINTS.adminClientSosMessage(id));
    if (!res || res.status !== 200) {
      console.error(`[sendSosMessage] 실패 status=${res?.status}`);
      throw new Error("SOS 메시지 전송 실패");
    }
  } catch (e: any) {
    console.error(`[sendSosMessage] 오류: ${e?.message ?? "알 수 없는 오류"}`);
    throw e;
  }
}

export async function fetchSosMessageHistory(params: {
  clientId: number;
  page?: number;
  size?: number;
  sort?: string;
  recipientType?: RecipientType | null;
}): Promise<SosMessageLogPage> {
  const { clientId, page = 0, size = 10, sort = "id,DESC", recipientType = null } = params;
  const url = API_ENDPOINTS.adminClientSosMessageList(clientId);
  const query: Record<string, any> = { page, size, sort };
  if (recipientType !== null) query.recipientType = recipientType;
  const { data } = await api.get<SosMessageLogPage>(url, { params: query });
  return data;
}